import React from 'react';
import PropTypes from 'prop-types';
import ChartKendaraya from 'components/LH/HC/Chart';

const HCCharts = ({ horoscopeData }) => {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '0px' }}>
            <div style={{ width: 400, height: 400 }}>
                <ChartKendaraya
                    devision="D1"
                    lagna={horoscopeData.lagna}
                    rashiId={null}
                    lagnaSputaya={horoscopeData.lagnaSputaya}
                    planets={horoscopeData.planet}
                />
            </div>
            <div style={{ width: 400, height: 400 }}>
                <ChartKendaraya
                    devision="D9"
                    lagna={horoscopeData.navamsaka}
                    rashiId={null}
                    lagnaSputaya={horoscopeData.navamsakaSputaya}
                    planets={horoscopeData.planet}
                />
            </div>
        </div>
    );
};
HCCharts.propTypes = {
    horoscopeData: PropTypes.shape({
        lagna: PropTypes.any,
        lagnaId: PropTypes.any,
        lagnaSputaya: PropTypes.any,
        navamsaka: PropTypes.any,
        navamsakaId: PropTypes.any,
        navamsakaSputaya: PropTypes.any,
        planet: PropTypes.any,
    }).isRequired,
};
export default HCCharts;
